class RevealButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // set target element by data-target attribute
    if (!this.dataset.target) {
      console.error('reveal-button: data-target attribute is not set');
      return;
    }

    this.target = document.querySelector(this.dataset.target);
    if (!this.target) {
      console.error('reveal-button: target element is not found');
      return;
    }

    // set click event listener
    this.addEventListener('click', () => {
      this.target.classList.add('open');
    });
  }

  disconnectedCallback() {
    // remove click event listener
    this.removeEventListener('click', () => {
      this.target.classList.add('open');
    });
  }
}

window.customElements.define('reveal-button', RevealButton);
